/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { MenuItem } from "."
import { 
  overviewReportsPath,
} from "api/endpoints"
import { FormattedMessage, injectIntl } from "react-intl";

function ReportSection(props) {
  const { intl } = props
  const cProps = {
    intl: intl,
    display: true,
    parentTitleId: "MENU.REPORTS"
  }

  return (
      <>
        <li className="menu-section ">
          <h4 className="menu-text"><FormattedMessage id="MENU.REPORTS" /></h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        <MenuItem
          {...cProps}
          titleId={"MENU.REPORTS.OVERVIEW"}
          url={overviewReportsPath}
          icon="/media/svg/icons/Shopping/Chart-bar1.svg"
          />
      </>
  );
}

export default injectIntl(ReportSection)